import { Mode } from './enums';
import css from './style.module.css';

export const modePresets: Record<Mode, string> = {
  [Mode.BOTTOM]: css.bottom,
  [Mode.TOP]: css.top,
};
